import { ViewportScroller } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonShapeEnum } from '../buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { CtaButtonTypeEnum } from '../call-to-action/enums/button-type.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { Subscription } from 'rxjs';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { DEFAULT_LOADER_STATE_KEY } from '~/core/services/loader/loader.service';

@Component({
  selector: 'app-pagination-buttons',
  templateUrl: './pagination-buttons.component.html',
  styleUrls: ['./pagination-buttons.component.scss'],
})
export class PaginationButtonsComponent implements OnInit {
  @Input() public hasLoadMoreButton = false;
  @Input() public loaderKey = DEFAULT_LOADER_STATE_KEY;
  @Input() public reviewsLabel = false;

  @Output() public loadMore = new EventEmitter<void>();

  private readonly subscriptions = new Subscription();

  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public isMobileDevice: boolean;

  constructor(
    private readonly matchMediaService: MatchMediaService,
    private readonly viewportScroller: ViewportScroller
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public goBackUp(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
